import { useParams } from "react-router-dom";
import Logs from "screens/components/Logs";

function OrganisationLogs() {
    const { organisationId } = useParams();
    return <Logs organisationId={organisationId}/>
}

export default OrganisationLogs;